import { IonIcon, IonItem, IonItemDivider, IonItemGroup, IonLabel, IonList, IonNote } from '@ionic/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { IBookingSummaryProps } from './booking-summary-props.interface'
import './booking-summary.scss'
import { icon_calendar } from 'icons'
import { parse, differenceInDays, format } from 'date-fns'
import { dateService } from 'services'
import { TotalPrice } from 'components'

const BookingSummary: React.FC<IBookingSummaryProps> = ({ booking }) => {
  const { t } = useTranslation()

  const now = new Date()
  const dateFrom = parse(booking.dateFrom, dateService.LOCAL_STORAGE_DATE_FORMAT, now)
  const dateTo = parse(booking.dateTo, dateService.LOCAL_STORAGE_DATE_FORMAT, now)
  const numDays = differenceInDays(dateTo, dateFrom)
  return (
    <div className="edisu-booking-summary">
      <div className="header">
        <IonItem lines="none">
          <IonLabel> {format(dateFrom, 'dd/MM/yyyy') + ' - ' + format(dateTo, 'dd/MM/yyyy')}</IonLabel>
          <IonIcon icon={icon_calendar} size="large" slot="start"></IonIcon>
        </IonItem>
      </div>
      <div className="content">
        <IonList>
          <IonItemGroup>
            <IonItemDivider>
              <IonLabel className="ion-text-uppercase">{t('room_summary')}</IonLabel>
            </IonItemDivider>

            {booking.guestsPerRoom.map((sr) => {
              return (
                <IonItem key={sr.value + '' + sr.room.id} lines="none">
                  <IonLabel>
                    {sr.value > 1 ? sr.value + ' ' + t('more_beds') : sr.value + ' ' + t('one_bed')} in {sr.room.descrizione}{' '}
                    {numDays > 1 ? numDays + ' ' + t('nights') : numDays + ' ' + t('night')}
                  </IonLabel>
                  <IonNote slot="end">{sr.room.prezzo} €</IonNote>
                </IonItem>
              )
            })}
          </IonItemGroup>

          {booking.extraServices && booking.extraServices.length > 0 && (
            <IonItemGroup>
              <IonItemDivider>
                <IonLabel className="ion-text-uppercase">{t('services_summary')}</IonLabel>
              </IonItemDivider>

              {booking.extraServices.map((s) => {
                return (
                  <IonItem key={s.id} lines="none">
                    <IonLabel>
                      {s.descrizione} x {s.prezzo} €
                    </IonLabel>
                    <IonNote slot="end">{s.prezzo * booking.guestsPerRoom.length} €</IonNote>
                  </IonItem>
                )
              })}
            </IonItemGroup>
          )}
        </IonList>
      </div>

      <div className="footer">
        <TotalPrice price={booking.totalPrice} />
        {/* TODO <IonItem className="caparra" lines="none">
          <IonLabel>{t('caparra')}</IonLabel>
          <IonNote slot="end">
            {booking.totalPrice % numDays === 0
              ? booking.totalPrice / numDays
              : (booking.totalPrice / numDays).toFixed(2).replace('.', ',')}
            {' €'}
          </IonNote>
        </IonItem> */}
      </div>
    </div>
  )
}

export default BookingSummary
